import { useEffect, useState } from 'react'
import { Button, Dialog } from '@floorfile/ui'
import { useCopy } from '@floorfile/i18n'
import { STALE_UPDATE_EVENT, type StaleUpdateEventDetail } from '@/lib/api-response'
import { appCopy } from '../copy'

function recordVersion(current: unknown): number | undefined {
  if (!current || typeof current !== 'object' || !('version' in current)) return undefined
  const version = (current as { version?: unknown }).version
  return typeof version === 'number' ? version : undefined
}

/** One recovery surface for every optimistic-concurrency protected edit. */
export function StaleUpdateDialog() {
  const copy = useCopy(appCopy).staleUpdate
  const [conflict, setConflict] = useState<StaleUpdateEventDetail>()

  useEffect(() => {
    const onConflict = (event: Event) => setConflict((event as CustomEvent<StaleUpdateEventDetail>).detail)
    window.addEventListener(STALE_UPDATE_EVENT, onConflict)
    return () => window.removeEventListener(STALE_UPDATE_EVENT, onConflict)
  }, [])

  const currentVersion = recordVersion(conflict?.current)
  return (
    <Dialog
      open={conflict !== undefined}
      onClose={() => setConflict(undefined)}
      title={copy.title}
      description={copy.description}
    >
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          {conflict?.message ?? copy.modified}
          {currentVersion !== undefined ? ` ${copy.latestVersion({ version: currentVersion })}` : ''}
        </p>
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" onClick={() => setConflict(undefined)}>
            {copy.keepDraft}
          </Button>
          <Button onClick={() => window.location.reload()}>
            {copy.reloadLatest}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
